import { render, staticRenderFns } from "./CookieBox.vue?vue&type=template&id=22278c7a&scoped=true&"
import script from "./CookieBox.vue?vue&type=script&lang=js&"
export * from "./CookieBox.vue?vue&type=script&lang=js&"
import style0 from "./CookieBox.vue?vue&type=style&index=0&id=22278c7a&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../var/task/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "22278c7a",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/task/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('22278c7a')) {
      api.createRecord('22278c7a', component.options)
    } else {
      api.reload('22278c7a', component.options)
    }
    module.hot.accept("./CookieBox.vue?vue&type=template&id=22278c7a&scoped=true&", function () {
      api.rerender('22278c7a', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "tmp/tmp-8qQoQNTxTaJv9/JS/comp/CookieBox.vue"
export default component.exports